<div class="header">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" routerLink=""><img src="../../assets//img//logoquiz.png" class="logo"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">     
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" routerLink="/">Accueil</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" routerLink="/quiz">Quiz</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" routerLink="/quiz">Jouer</a>
            </li>
            <li class="nav-item">
               <a class="nav-link" routerLink="/creerjeu">Créer</a> 
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/compte">{{username}}</a> 
           </li>
           <li class="nav-item" *ngIf="connected">
            <a class="nav-link" (click)="Deconnexion()" routerLink="/">Déconnexion</a> 
         </li>
          </ul>
        </div>
      </nav>
</div>
